// German translations for onboarding
// Location: src/i18n/locales/de/onboarding.ts

export default {
  header: {
    step: 'Schritt {{current}} von {{total}}',
  },

  progress: {
    goal: 'Ziel',
    bio: 'Bio',
    activity: 'Aktivität',
    diet: 'Ernährung',
    plan: 'Plan',
  },

  navigation: {
    back: 'Zurück',
    continue: 'Weiter',
    createPlan: 'Plan erstellen',
    building: 'Plan wird erstellt...',
  },

  step1: {
    title: "Was ist dein Hauptziel?",
    subtitle: 'Wähle das Ziel, das deine Fitnessreise am besten beschreibt',
    goals: {
      lose: {
        label: 'Abnehmen',
        description: 'Fett verbrennen und Körpergewicht reduzieren',
      },
      maintain: {
        label: 'Gewicht halten',
        description: 'Gesund und ausgeglichen bleiben',
      },
      build: {
        label: 'Muskeln aufbauen',
        description: 'Kraft und Muskelmasse gewinnen',
      },
    },
  },

  step2: {
    title: "Lass uns dich kennenlernen",
    subtitle: 'Erzähl uns etwas über dich, um deinen Plan zu personalisieren',
    gender: {
      label: 'Geschlecht',
      male: 'Männlich',
      female: 'Weiblich',
      diverse: 'Divers',
    },
    age: {
      label: 'Alter',
      placeholder: '25',
    },
    height: {
      label: 'Größe (cm): {{height}} cm',
    },
    weight: {
      label: 'Aktuelles Gewicht (kg)',
    },
    targetWeight: {
      label: 'Zielgewicht (kg)',
    },
  },

  step3: {
    title: 'Wie aktiv bist du täglich?',
    subtitle: 'Dies hilft uns, deinen Kalorienbedarf zu berechnen',
    levels: {
      sedentary: {
        label: 'Sitzend',
        description: 'Bürojob, wenig bis kein Sport',
      },
      lightly: {
        label: 'Leicht aktiv',
        description: 'Leichter Sport 1-3 Tage/Woche',
      },
      moderately: {
        label: 'Moderat aktiv',
        description: 'Moderater Sport 3-5 Tage/Woche',
      },
      very: {
        label: 'Sehr aktiv',
        description: 'Harter Sport 6-7 Tage/Woche',
      },
      extremely: {
        label: 'Extrem aktiv',
        description: 'Sehr harter Sport, körperliche Arbeit',
      },
    },
  },

  step4: {
    title: 'Ernährungspräferenzen?',
    subtitle: 'Wähle alles aus, um deinen Essensplan anzupassen',
    dietType: {
      title: 'Ernährungsweise',
      subtitle: '(Wähle eine)',
    },
    diets: {
      balanced: 'Ausgewogen',
      vegetarian: 'Vegetarisch',
      vegan: 'Vegan',
      keto: 'Keto',
      paleo: 'Paleo',
    },
    allergies: {
      title: 'Allergien/Ausschlüsse',
      subtitle: '(Mehrfachauswahl)',
    },
    allergyItems: {
      gluten: 'Gluten',
      lactose: 'Laktose',
      nuts: 'Nüsse',
      soy: 'Soja',
      eggs: 'Eier',
      fish: 'Fisch',
      shellfish: 'Meeresfrüchte',
      peanuts: 'Erdnüsse',
    },
  },

  step5: {
    title: 'Wähle deinen Plan',
    subtitle: 'Wähle den Plan, der zu deinen Zielen passt',
    plans: {
      basic: {
        title: 'BASIC',
        price: 'CHF 14.90',
        period: '/Monat',
        feature1: 'Statische Ernährungspläne',
        feature2: 'Standard-Basisfunktionen',
        feature3: 'Kalorien & Zutaten pro Tag',
        missing1: 'Kein Zugang zu NutriBot',
        missing2: 'Keine Einkaufslisten',
        missing3: 'Keine Echtzeit-Anpassungen',
      },
      vip: {
        title: 'VIP',
        price: 'CHF 29.90',
        period: '/Monat',
        recommended: 'EMPFOHLEN',
        feature1: 'Voller Zugang zu NutriBot',
        feature2: 'Wöchentliche VIP-Rezepte',
        feature3: 'Smarte Einkaufslisten',
        feature4: 'Echtzeit-Plan-Anpassungen',
        feature5: 'Motivation & Coaching-Inhalte',
        feature6: 'PDF-Exporte & Fortschritts-Tracking',
        benefitsTitle: 'VIP Vorteile',
        benefitsDesc: 'Erhalte personalisiertes AI-Coaching, wöchentliche Rezept-Updates und Echtzeit-Anpassungen, um deine Ziele schneller zu erreichen.',
      },
    },
    footer: {
      vip: "🎉 Du wählst den besten Plan! Jederzeit kündbar.",
      basic: "✨ Starte mit Basic und upgrade jederzeit auf VIP!",
      none: "Wähle einen Plan, um fortzufahren",
    },
  },

  step6: {
    title: 'Mahlzeitenpräferenzen',
    subtitle: 'Passe deine Mahlzeitenstruktur an',
    mealsPerDay: {
      label: 'Mahlzeiten pro Tag',
    },
    allergies: {
      label: 'Allergien (wähle alle zutreffenden)',
      items: {
        gluten: 'Gluten',
        lactose: 'Laktose',
        nuts: 'Nüsse',
        soy: 'Soja',
        eggs: 'Eier',
        fish: 'Fisch',
        shellfish: 'Schalentiere',
        peanuts: 'Erdnüsse',
      },
    },
    intolerances: {
      label: 'Unverträglichkeiten (optional)',
      items: {
        dairy: 'Milchprodukte',
        gluten: 'Gluten',
        grain: 'Getreide',
        sulfites: 'Sulfite',
        fodmap: 'FODMAP',
        sesame: 'Sesam',
      },
    },
  },

  step7: {
    title: 'Überprüfe dein Profil',
    subtitle: 'Alles in Ordnung? Lass uns deinen Plan erstellen!',
    edit: 'Bearbeiten',
    personal: {
      title: 'Persönliche Informationen',
      gender: 'Geschlecht',
      age: 'Alter',
      ageValue: '{{age}} Jahre',
      height: 'Größe',
      heightValue: '{{height}} cm',
      weight: 'Gewicht',
      weightValue: '{{weight}} kg',
    },
    goals: {
      title: 'Ziele & Aktivität',
      goal: 'Ziel',
      target: 'Zielgewicht',
      targetValue: '{{weight}} kg',
      timeframe: 'Zeitrahmen',
      timeframeValue: '{{days}} Tage',
      activity: 'Aktivität',
    },
    diet: {
      title: 'Ernährungspräferenzen',
      type: 'Ernährungstyp',
      meals: 'Mahlzeiten pro Tag',
      mealsValue: '{{count}} Mahlzeiten',
      allergies: 'Allergien',
      intolerances: 'Unverträglichkeiten',
    },
    button: 'Meinen personalisierten Plan erstellen',
    saving: 'Wird gespeichert...',
    note: '🎉 Dein personalisierter Ernährungsplan wird in 2-3 Minuten fertig sein!',
  },
  addAllergy: {
    title: 'Benutzerdefinierte Allergie hinzufügen',
    description: 'Gib eine Zutat oder ein Lebensmittel ein, auf das du allergisch reagierst, damit wir deine Mahlzeiten anpassen können.',
    inputPlaceholder: 'z. B. Erdnüsse',
    cancel: 'Abbrechen',
    add: 'Hinzufügen'
  }
};